import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import c from '~/utils/constants';

const OatCard: FC<{ className?: string; borderBottomNoRadius?: boolean }> = (props) => {
  const { className, children, borderBottomNoRadius, ...rest } = props;
  return (
    <div className={`${className} OatCard`} {...rest}>
      {children}
    </div>
  );
};

export default styled(OatCard)`
  background-color: #fafafa;
  border: 1px solid #e6e6e6;
  border-radius: ${c.borderRadiusBase}px;
  padding: 12px 16px;
  ${({ borderBottomNoRadius }) =>
    borderBottomNoRadius &&
    css`
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    `}
`;
